<template>
  <div class="admin-page">
    <div v-if="!isAdmin" class="permission-denied">
      <el-result icon="warning" title="权限不足" sub-title="您需要管理员权限才能访问此页面">
        <template #extra>
          <el-button type="primary" @click="$router.push('/knowledge/courses')">返回课程页面</el-button>
        </template>
      </el-result>
    </div>
    <template v-else>
      <h2 class="page-title">课程云视频</h2>
      <CourseOssPanel admin-mode :initial-kc-id="$route.query.kcId" />
    </template>
  </div>
</template>

<script>
import CourseOssPanel from './components/CourseOssPanel.vue'
import { isSystemAdmin } from '@/utils/sysRole'

export default {
  name: 'AdminCourseOssView',
  components: { CourseOssPanel },
  data() {
    return { isAdmin: false }
  },
  created() {
    const userInfo = localStorage.getItem('user_info')
    if (userInfo) {
      try {
        this.isAdmin = isSystemAdmin(JSON.parse(userInfo).sysRole)
      } catch (_) {
        this.isAdmin = false
      }
    }
  }
}
</script>

<style scoped>
.page-title { margin: 0 0 12px; font-size: 20px; }
</style>
